export { SessionReplayUGC } from './SessionReplayUGC';
